// MEGA MENU

$(document).click(function (event) {
  var $target = $(event.target);
  if (!$target.closest('.child').length &&
    $('.child').is(":visible")) {
    $('.child').removeClass('active');
  }
});

jQuery(document).ready(function ($) {

  $('.c-main-nav > ul > li.drop-menu button').click(function () {

    if ($(this).parent('li').hasClass('active')) {
      $('li.child').removeClass('active');
    }
    else {
      $('li.child').removeClass('active');
      $(this).parent('li').addClass('active');
    }

    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true';
    });
  });
  
});

// ADA Menu

jQuery(document).ready(function ($) {

  $('.c-ada-mega-menu--btn').on('click', function () {

    if ($(this).parent('li').hasClass('active')) {
      $('li.child').removeClass('active');
    }
    else {
      $('li.child').removeClass('active');
      $(this).parent('li').addClass('active');
    }

    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true';
    });
  });

  $('.c-ada-mega-menu--btn').keypress(function (e) {
    if (e.which == 13) {
      $(this).addClass('active');
      $('li.child').removeClass('active');
      $(this).parent('li').addClass('active');

      $(this).attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true';
      });
    }
  });

  $('.c-ada-mega-menu--close').on('click', function () {
      $('.c-ada-mega-menu--btn').removeClass('active');
      $('.child').removeClass('active');

      $('c-ada-mega-menu--btn').attr('aria-expanded', function (i, attr) {
        return attr == 'false';
      });
  });

  $('.c-ada-mega-menu--close').keypress(function (e) {
    if (e.which == 13) {
      $('.c-ada-mega-menu--btn').removeClass('active');
      $('.child').removeClass('active');

      $('c-ada-mega-menu--btn').attr('aria-expanded', function (i, attr) {
        return attr == 'false';
      });
    }
  });

});

